import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { paths } from './paths';

const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  const location = useLocation();

  if (!token) {
    // Bounce to the sign-in page of whichever UI you were trying to reach. Sending a
    // /v1 visitor to the old /signin would drop them into the old dashboard on login,
    // making /v1 look broken when it was only ever the redirect.
    const signin = location.pathname.startsWith(paths.v1.root)
      ? paths.v1.signin
      : paths.auth.signin;
    return <Navigate to={signin} state={{ from: location }} replace />;
  }

  return children;
};

export default PrivateRoute;
